import { Bound } from "lib/@components/binding/Bound"
import { Box, Divider, Stack } from "@mui/material"
import { EditModeSwitch } from "routes/schedule/compare/edit-mode-switch"
import { TaskRowEnd } from "slot-definitions"
import { StatusButton } from "routes/schedule/compare/status"
import noop from "lib/noop"
import { Approved } from "routes/schedule/compare/approved"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { Frag } from "lib/@components/slot/frag"
import { If } from "lib/@components/switch"

export function TwoSchedules({
    leftSchedule,
    showCopy,
    after = null,
    below = null,
    copy = noop,
    revert = noop,
    copied = false,
    rightSchedule,
    left,
    right,
    to = rightSchedule,
    disabled,
}) {
    TaskRowEnd.usePlug(replaceAllWith(<Frag />))
    return (
        <Bound
            alwaysOpenTask={true}
            showAll={true}
            to={to}
            originalTarget={rightSchedule}
            editMode={false}
            shouldPopupTextEditor={false}
            hideDrag={true}
        >
            <Stack
                className="two-schedules"
                spacing={0}
                direction="row"
                sx={{ overflow: "hidden", width: 1, position: "relative" }}
            >
                <Box width={1 / 2} pl={4} className="left" data-cy="comparison-left-column">
                    <EditModeSwitch disabled={disabled || !showCopy}>
                        <Bound schedule={leftSchedule} target={leftSchedule}>
                            {left}
                            <If value={showCopy}>
                                <Box className="after" ml={-4} mb={1}>
                                    {after}
                                </Box>
                            </If>
                        </Bound>
                    </EditModeSwitch>
                </Box>
                <Approved width={116} fill={true}>
                    <Box className="center" alignSelf="center" justifySelf="center" minWidth={80}>
                        <StatusButton show={showCopy} copy={copy} copied={copied} revert={revert} />
                    </Box>
                    <Box className="right" width={1 / 2} pr={4} data-cy="comparison-right-column">
                        <Bound schedule={rightSchedule} target={rightSchedule}>
                            {right}
                        </Bound>
                    </Box>
                </Approved>
            </Stack>
            {below}
            <Divider my={1} />
        </Bound>
    )
}
